export default {
  blends: {
    validationMessage:{
      requiredMessage:'Dit veld is verplicht',
      isNumber:'Moet een getal zijn',
      isValidNumber:'Moet een geldig nummer zijn',
      noNegativeNumbers:'Moet een positief nummer zijn',
      atLeastTwoProducts: 'Er zijn minimaal twee producten vereist',
    },
    exemptProducts: {
      eudrExemptProducts: 'EUDR-vrijgestelde Producten',
      addEUDRExemptProduct: 'Voeg EUDR-vrijgesteld Product Toe',
      updateEUDRExemptProduct: 'Werk EUDR-vrijgesteld Product Bij',
      internalRefNumber: 'Intern Referentienummer',
      supplier: 'Leverancier',
      containerID: 'Container-ID',
      product: 'Product',
      quantity: 'Hoeveelheid',
      dateAdded: 'Datum Toegevoegd',
      addProduct: 'Voeg Product Toe',
      selectDate: 'Selecteer Datum',
      addContainer: 'Voeg Container Toe',
      containerInformation: 'Containerinformatie',
      supplierInformation: 'Leveranciersinformatie',
      supplierInformationTT:
        'Details over de entiteit die goederen of diensten levert.',
      supplierTooltip:
        'Selecteer de leverancier uit de vooraf geregistreerde lijst in het systeem.',
      addnewSupplier: 'Nieuwe Leverancier Toevoegen',
      internalReferenceNumberMustBeAlphanumeric:
        'Het interne referentienummer moet alfanumeriek zijn',
      netMassMustBeValid: 'Netto massa moet geldig zijn',
      volumeMustBeNumeric: 'Volume moet numeriek zijn',
      subProduct: 'Subproduct',
      netMass: 'Netto Massa',
      volume: 'Volume',
      productDetail: 'Productdetails',
      placeOfActivity: 'Plaats van Activiteit',
      countryOfActivity: 'Land van Activiteit',
      countryOfEntry: 'Land van Binnenkomst',
      activity: 'Activiteit',
      internalRefNo: 'Intern Referentienummer',
      name: 'Naam',
      email: 'E-mail',
      phoneNumber: 'Telefoonnummer',
      country: 'Land',
      status: 'Status',
      addNewSupplier: 'Nieuwe Leverancier Toevoegen',
      availableForBlends: 'Beschikbaar voor Mengsels',
      thisFieldIsRequired: 'Dit veld is verplicht.',
      enterSupplierFirstName: 'Voer Voornaam van Leverancier in',
      enterSupplierLastName: 'Voer Achternaam van Leverancier in',
      enterEmailAddress: 'Voer E-mailadres in',
      enterPhoneNumber: 'Voer Telefoonnummer in',
      selectCountry: 'Selecteer Land',
      firstNameIsRequired: 'Voornaam is verplicht',
      lastNameIsRequired: 'Achternaam is verplicht',
      unAvailableForBlends: 'Niet Beschikbaar voor Mengsels',
      exemptAddedSuccessfully:
        'EUDR-vrijgesteld product is succesvol toegevoegd!',
      unExpectedErrorMsg:
        'Er is een onverwachte fout opgetreden. Probeer het opnieuw.',
      availabilityStatusMsg:
        'De beschikbaarheidsstatus voor mengsels is succesvol bijgewerkt.',
      updateProduct: 'Werk Product Bij',
      exemptUpdatedSuccessfully:
        'EUDR-vrijgesteld product is succesvol bijgewerkt!',
      invalidNumericValue: 'Ongeldige numerieke waarde',
      containerIDTT:
        'Dit is een unieke identificatie van de container. Voer hieronder de Container-ID in.',
        actions: 'Acties',
    },
  
    blends: 'Mengsels',
    blendSetting: 'Mengselinstellingen',
    createBlendDds: 'Creëer Mengsel Dds',
    country: 'Land',
    countryTT: 'Land',
    select: 'Selecteren',
    edurDueDeligenceStatus: 'EUDR Due Diligence Status',
    dueDiligenceStatus: 'Due Diligence Status',
    EUDRDeforestationStatusTT: 'EUDR Ontbossingsstatus',
    dueDeligenceStatus: 'Due Diligence Status',
    uploadedToEU: 'Geüpload naar EU',
    pending: 'In behandeling',
    underReview: 'In beoordeling',
    compliant: 'Conform',
    nonCompliant: 'Niet-conform',
    processingFarm: 'Verwerkende Boerderij',
    analyzingDeforestation: 'Ontbossing Analyseren',
    writingToBlockchain: 'Schrijven naar Blockchain',
    readyToProceed: 'Klaar om verder te gaan',
    mitigationRequired: 'Mitigatie Vereist',
    viewReport: 'Bekijk Rapport',
    share: 'Delen',
    copyAndCreateNew: 'Kopiëren en Nieuw Maken',
    remove: 'Verwijderen',
    eudrRefNo: 'EUDR/Interne Referentie Nr.',
    finalProduct: "Titel van Mengsel & ID van Mengsel Lot",
    noOfIngredients: 'Aantal Ingrediënten',
    farmsAndQuantity: 'Boerderijen & Hoeveelheid',
    actions: 'Acties',
    confirmDialog: {
      delete: {
        title: 'Verwijder Mengsel',
        message: 'Weet u zeker dat u dit Mengsel wilt verwijderen?',
        confirmBtn: 'Bevestigen',
        cancelBtn: 'Annuleren',
      },
    },
    searchBlend: 'Zoek Mengsel op Eindproduct',
    blendDuplicatedSuccessfully: 'Mengsel succesvol gedupliceerd.',
    reportDeletedSuccessfully: 'Rapport succesvol verwijderd.',
    blendSettings: {
      dashboard: 'Dashboard',
      blendSettings: 'Instellingen Mengsels',
      importBlends: 'Mengsels Importeren',
      addNewBlend: 'Nieuwe Mengsel Toevoegen',
      searchTitle: 'Zoek op Titel van Mengsel',
      view: 'Bekijken',
      edit: 'Bewerken',
      remove: 'Verwijderen',
      farms: 'Boerderijen',
      blendCode: 'Mengselcode',
      blendTitle: 'Titel van Mengsel',
      description: 'Beschrijving',
      'finalProductName&Code': 'Naam en Code van Eindproduct',
      dateAdded: 'Datum Toegevoegd',
      actions: 'Acties',
      addBlend: 'Instellingen Mengsel Toevoegen',
      cancel: 'Annuleren',
      createBlend: 'Mengsel Maken',
      generalData: 'Algemene Gegevens',
      generalDataTT: "Dit label toont alle gegevens op het scherm.",
      blendTitleTT: "De dropdown kan worden geopend door erop te klikken, waardoor een lijst met beschikbare mengsels voor selectie wordt weergegeven.",
      enterHere: 'Voer hier in',
      blendCodeTT: 'Mengselcode',
      blendDescription: 'Beschrijving van Mengsel',
      blendDescriptionTT: 'Beschrijving van Mengsel',
      finalProductName: 'Naam van Eindproduct',
      finalProductNameTT: 'Naam van Eindproduct',
      finalProductCode: 'Code van Eindproduct',
      finalProductCodeTT: 'Code van Eindproduct',
      processType: 'Type Proces',
      processTypeTT: 'Type Proces',
      finalProductLotIdGen: 'Generator Lot ID van Eindproduct Mengsel',
      finalProductLotIdGenTT: 'Generator Lot ID van Eindproduct Mengsel',
      productDetails: 'Mengselproducten (Ingrediënten)',
      productDetailsTT: 'Mengselproducten (Ingrediënten)',
      selectType: 'Selecteer Type',
      startCount: 'Starttelling',
      resetCounterEach: 'Reset Teller Elke',
      enter: 'Invoeren',
      staticText: 'Statische Tekst',
      incrementalNumber: 'Incrementeel Nummer',
      year: 'Jaar',
      month: 'Maand',
      date: 'Datum',
      none: 'Geen',
      space: 'Spatie',
      '0001': '0001',
      resetCounter: 'Reset teller elke',
      selectSeparator: 'Selecteer Scheidingsteken',
      previewLotId: 'Voorbeeld Lot ID',
      blendProducts: 'Mengselproducten',
      blendProductsTT: 'Mengselproducten',
      product: 'Product',
      productTT: 'Product',
      selectProduct: 'Selecteer Product',
      subProduct: 'Subproduct',
      subProductTT: 'Subproduct',
      selectSubProduct: 'Selecteer Subproduct',
      originCountry: 'Land van Oorsprong',
      originCountryTT: 'Land van Oorsprong',
      selectCountry: 'Selecteer Land',
      percentage: 'Percentage',
      percentageTT: 'Percentage',
      addAnotherProduct: 'Nog een Product Toevoegen',
      confirmation: 'Bevestiging',
      createBlendMessage: 'Weet u zeker dat u een nieuw mengsel wilt toevoegen?',
      updateBlendMessage: 'Weet u zeker dat u dit mengsel wilt bijwerken?',
      confirm: 'Bevestigen',
      pleaseFillRequiredFields: 'Vul alstublieft de verplichte velden in',
      lightRoast: 'Lichte Branding',
      mediumRoast: 'Middel Branding',
      mediumDarkRoast: 'Middel-Donkere Branding',
      darkRoast: 'Donkere Branding',
      validation: {
        titleRequired: 'Titel is verplicht',
        codeRequired: 'Mengselcode is verplicht',
        descriptionRequired: 'Beschrijving is verplicht',
        finalProductNameRequired: 'Naam van eindproduct is verplicht',
        finalProductCodeRequired: 'Code van eindproduct is verplicht',
        processTypeRequired: 'Processtype is verplicht',
        selectTypeRequired: 'Type is verplicht',
        startCountRequired: 'Starttelling is verplicht',
        selectSeparatorRequired: 'Scheidingsteken is verplicht',
        finalProductLotIdGenRequired:
          'Lot ID generator voor eindproduct is verplicht',
        productRequired: 'Product is verplicht',
        subProductRequired: 'Subproduct is verplicht',
        originCountryRequired: 'Land van oorsprong is verplicht',
        percentageRequired: 'Percentage is verplicht',
        hundredPrecent: 'Het totaalpercentage moet exact 100% zijn',
        productSubproductDuplicatedMsg: 'Product en subproduct zijn gedupliceerd',
      },
      mustSelectIncrementalNumber:
        'Er moet ten minste één incrementeel nummer worden geselecteerd',
      blendSettingsCreated: 'Mengselinstellingen succesvol aangemaakt.',
      blendSettingsNotCreated:
        'Aanmaken van mengselinstellingen is mislukt. Probeer opnieuw met de juiste gegevens.',
      confirmDiaglog: {
        delete: {
          title: 'Verwijderen',
          message:
            'Weet u zeker dat u deze mengselinstellingen wilt verwijderen?',
          confirmBtn: 'Bevestigen',
          cancelBtn: 'Annuleren',
        },
      },
      itemDeletedSuccessfully: 'Mengselinstellingen succesvol verwijderd',
      updateBlend: 'Mengselinstellingen Bijwerken',
      save: 'Opslaan',
      blendSettingsUpdated: 'Mengselinstellingen succesvol bijgewerkt.',
      blendSettingsNotUpdated:
        'Bijwerken van mengselinstellingen is mislukt. Probeer opnieuw met de juiste gegevens.',
      updateMessage: 'Weet u zeker dat u dit mengsel wilt bijwerken?',
      createMessage: 'Weet u zeker dat u een nieuw mengsel wilt toevoegen?',
      finalProductCodeAlreadyExists: 'Code van eindproduct bestaat al',
      blendCodeAlreadyExists: 'Mengselcode bestaat al.',
      valueMustBeNumber: 'Dit veld moet een nummer zijn',
      valueMustBeNonNegative: 'Dit veld moet groter zijn dan nul',
    },

    imports: {
      imports: 'Importeren',
      blends: 'Mengsels',
      createNewImport: 'Maak Nieuwe Import',
      importsBlends: 'Importeer Mengsels',
      createBlends: 'Maak Mengsels',
      downloadTemplateInfo:
        'Download en gebruik de onderstaande sjablonen om geofences in bulk te importeren.',
      selectTemplate: 'Selecteer Sjabloon',
      downloadXlsTemplate: 'Download XLS Importeer Sjabloon',
      downloadProductCodes: 'Download Productcodes',
      selectFileToUpload: 'Selecteer een bestand om gegevens te uploaden',
      orDragDrop: 'Of sleep en zet bestanden hier neer',
      removeFile: 'Verwijder Bestand',
      importantNote: 'Belangrijke Opmerking',
      templateNote:
        'Gebruik de hierboven verstrekte sjablonen voor bulkuploads. Andere formaten zullen resulteren in een mislukking.',
      importData:'Zorg ervoor dat deze gegevens niet worden bewaard totdat alle statussen succesvol zijn.',
      fileUploadSuccess: 'Bestand succesvol geüpload',
      invalidFileFormat: 'Ongeldig bestandstype. Upload een geldig bestand',
      pleaseSelectSource: 'Selecteer ten minste één bron',
      blendTitle: 'Titel Mengsel',
      blendCode: 'Code Mengsel',
      finalProductCode: 'Code Eindproduct',
      finalProductName: 'Naam Eindproduct',
      status: 'Status',
      downloadCsvTemplate: 'Download CSV Importeer Sjabloon',
      dropHere: 'of sleep hier neer',
      Importing: 'Bezig met importeren...',
      modalMessage:
        'Uw geüploade bestand wordt momenteel verwerkt. We informeren u zodra het bestand succesvol is geüpload.',
      importXLSFormat: 'Importeer XLS-formaat',
      importCSVFormat: 'Importeer CSV-formaat',
      fileSelected: 'Het bestand is succesvol geselecteerd.',
      success: 'Gegevens succesvol geïmporteerd.',
      importCompleted: 'Importeren Voltooid',
      invalidHeaders: "Ongeldige Bestandskoppen",
      headerMismatchErro: "Het geüploade bestand moet de volgende koppen bevatten",
      missingHeaders: "Ontbrekende Koppen",
      additionalHeaders: "Extra Koppen (niet toegestaan)"
    },
    history: {
      history: 'Geschiedenis',
      fileName: 'Bestandsnaam',
      importedOn: 'Geïmporteerd op',
      status: 'Status',
      action: 'Actie',
      blends: 'Mengsels',
      download: 'Downloaden',
      success: 'Succes',
      failed: 'Mislukt'
    },
    createBlends: {
      eudrDueDiligence: 'EUDR Due Diligence',
      createBlends: 'Maak Mengsels',
      discard: 'Verwijderen',
      reject: 'Afwijzen',
      saveAndContinueLater: 'Opslaan en Later Doorgaan',
      generateReport: 'Rapport Genereren',
      generalData: 'Algemene Gegevens',
      blend: 'Mengsel',
      selectBlend: 'Selecteer Mengsel',
      blendCode: 'Mengselcode',
      blendDescription: 'Mengselbeschrijving',
      finalProduct: 'Eindproduct',
      finalProductCode: 'Code Eindproduct',
      netMass: 'Netto Massa',
      netMassTT: "Maakt het mogelijk voor gebruikers om de netto massa-belastingwaarde in te voeren die is gekoppeld aan een product, zending of transactie.",
      volume: 'Volume',
      volumeTT: "Het label wordt duidelijk weergegeven naast een veld of sectie waar volume-gerelateerde gegevens worden weergegeven of ingevoerd, zoals in productspecificaties of verzendformulieren.",
      blendLotId: 'Mengsel Lot ID',
      blendLotIdTT: "Toont de unieke partij-identificatie volgens de Blend-instellingenconfiguratie voor het volgen van de mengbatch.",
      finishedProductLotId: 'Lot ID Eindproduct',
      finishedProductLotIdTT: "Voer de unieke partij-identificatie in om de uiteindelijke productbatch te volgen.",
      enterHere: 'Hier Invoeren',
      internalReferenceNumber: 'Interne Referentienummer',
      internalReferenceNumberTT: "Interne referentiecode voor traceerdoeleinden.",
      eudrReferenceNumber: 'EUDR Referentienummer',
      eudrReferenceNumberTT: "EUDR (Europese Unie Ontbossingsverordening) nalevingsreferentiecode. Dit wordt automatisch ingevuld als de gebruiker het naar EUDR wil uploaden na het maken van het rapport.",
      companyId: 'Bedrijfs-ID',
      companyIdTT: "Identificatiecode voor het bedrijf dat aan deze blend is gekoppeld.",
      activity: 'Activiteit',
      domestic: 'Binnenlands',
      import: 'Importeren',
      export: 'Exporteren',
      containerInformation: 'Containerinformatie',
      containerInformationTT: "Dit is een unieke identificatie van de container. Voer hieronder het container-ID in.",
      addContainer: 'Container Toevoegen',
      blendProduct: 'Mengselproduct',
      blendProductTT: "Voeg meerdere producten en subproducten toe uit DDS/EUDR-vrijgestelde producten om een blend te maken.",
      product: 'Product',
      productTT: "Toont gebruikers het product dat is gekozen uit een lijst met beschikbare producten in de Blend-instelling voor verwerking, analyse of rapportage binnen de applicatie, wat een nauwkeurige gegevensinvoer en -beheer vergemakkelijkt.",
      subProduct: 'Subproduct',
      subProductTT: "Toont gebruikers de subproducten die zijn gekozen uit de beschikbare subproducten in de Blend-instelling die verband houden met een geselecteerd hoofdproduct, wat gedetailleerde gegevensinvoer en -beheer binnen de applicatie vergemakkelijkt.",
      ddsId: 'DDS ID',
      containerId: 'Container ID',
      uniqueContainerId:"Container-ID moet uniek zijn",
      containerIdTT: "Unieke identificatie voor de container die deze blend vervoert.",
      country: 'Land',
      countryTT: "Kies het land dat verbonden is met de oorsprong of bestemming van de blend.",
      search: 'Zoeken',
      select: 'Selecteren',
      addAnotherProduct: 'Nog een Product Toevoegen',
      customization: 'Aanpassing',
      recordsPerPage: 'Records per pagina',
      restoreDefault: 'Herstel Standaard',
      apply: 'Toepassen',
      applyFilter:"Filter toepassen",
      clearFilter:"Filter wissen",
      status: {
        compliant: 'Conform',
        nonCompliant: 'Niet-conform',
        uploadToEudr:"GEÜPLOAD NAAR HET EU-PORTAAL",
        eudrExempt: "VRIJGESTELD VAN EUDR",
      },
      table: {
        eudrInternalRef: 'EUDR / Intern Referentienummer',
        containerId: 'Container ID',
        product: 'Product',
        farmsQuantity: 'Boerderijen & Hoeveelheid',
        submissionDate: 'Indieningsdatum',
        dueDiligenceStatus: 'Due Diligence Status',
        availabilityForBlends: 'Beschikbaarheid voor Mengsels',
        pleaseSelectSource: 'Selecteer minstens één bron',
      },
      productionPlaceTable: {
        productionPlaceAndFarmId: 'Productieplaats en Boerderij-ID',
        product: 'Product',
        producerName: 'Naam Producent',
        addressOfProduction: 'Adres van Productie',
        status: 'EUDR Ontbossingsstatus',
        riskAssessment: 'Risicobeoordeling',
      },
      
      addNewSupplier: 'Nieuwe Leverancier Toevoegen',
      addNewBlend: 'Nieuwe Mengsel Toevoegen',
      placeOfActivity: 'Plaats van Activiteit van de Operator',
      placeOfActivityTT: "Specificeer het land van de operator waar de activiteiten worden uitgevoerd en het land waar het product de EU-markt betreedt. Deze details zijn essentieel voor naleving van de EUDR-vereisten.",
      countryOfActivity: 'Land van Activiteit van de Operator',
      countryOfActivityTT: "Selecteer het land waar deze activiteit plaatsvindt.",
      countryOfEntry: 'Land van Binnenkomst',
      countryOfEntryTT: "Selecteer het land van binnenkomst voor geïmporteerde producten.",
      pleaseSelectAtLeastOne: 'Selecteer minstens één rapport van elk product',
      blendCreatedSuccessfully: "Blend is succesvol aangemaakt.",
      blendCreateFailed: "Er is een fout opgetreden bij het maken van de blend.",
      blendUpdatedSuccessfully: "Blend is succesvol bijgewerkt.",
      blendUpdateFailed: "Er is een fout opgetreden bij het bijwerken van de blend.",
      blendDeletedSuccessfully: "Blend is succesvol verwijderd.",
      blendSavedSuccessfully: 'Blend is succesvol opgeslagen.',
      blendUploadedToEUSuccessfully: "Blend is succesvol geüpload naar de EU."
    },
    manageProducts: {
      addNewProduct: 'Nieuw Product Toevoegen',
      editProduct: 'Product Bewerken',
      addNewSubProduct: 'Nieuw Subproduct Toevoegen',
      editSubProduct: 'Subproduct Bewerken',
      productTitle: 'Producttitel',
      subProductTitle: 'Subproducttitel',
      typeTitle: 'Typ Titel',
      hsCode: 'HS-code',
      typeHSCode: 'Typ HS-code',
      eudrDocumentCode: 'EUDR-documentcode',
      selectEudrDocumentCode: 'Selecteer EUDR-documentcode',
      makeSelection: 'Maak een selectie',
      uploadCategoryImage: 'Categorieafbeelding Uploaden',
      addImage: 'Afbeelding Toevoegen',
      cancel: 'Annuleren',
      save: 'Opslaan',
      back: 'Terug',
      add: 'Toevoegen',
      confirm: 'Bevestigen',
      deleteMessage: 'Weet u zeker dat u wilt verwijderen',
      invalidFileType: 'Ongeldig Bestandstype',
      errorUploadingFile:
        'Er is een onverwachte fout opgetreden bij het uploaden van het bestand. Probeer het later opnieuw.',
      fileUploadFailed: 'Bestand Uploaden Mislukt',
      selectDocumentCode: 'Selecteer Documentcode',
      view: 'Bekijken',
      edit: 'Bewerken',
      remove: 'Verwijderen',
      search: 'Zoeken',
      searchByProductName: 'Zoek op Productnaam',
      eudrDueDiligence: 'EUDR Due Diligence',
      products: 'Producten',
      subProducts: 'Subproducten',
      fieldRequired: 'Dit veld is verplicht',
      fileRequired: 'Bestand Vereist',
      fileRequiredMessage:
        'Upload of selecteer een bestand voordat u het product opslaat.',
      addNewDocumentCode: 'Nieuwe Documentcode Toevoegen',
      enterHere: 'Voer hier in',
      documentCode: 'Documentcode',
      title: 'Titel',
      description: 'Beschrijving',
      updateProduct: 'Product Bijwerken',
      updateSubProduct: 'Subproduct Bijwerken',
      deleteSubProduct: 'Subproduct Verwijderen',
      deleteProduct: 'Product Verwijderen',
      productAddedMessage: 'Product is succesvol toegevoegd.',
      subProductAddedMessage: 'Subproduct is succesvol toegevoegd.',
      productUpdateMessage: 'Product is succesvol bijgewerkt.',
      subProductUpdateMessage: 'Subproduct is succesvol bijgewerkt.',
      subProductDeleteMessage: 'Subproduct is succesvol verwijderd.',
      productDeleteMessage: 'Product is succesvol verwijderd.',
      pleaseTryAgain: 'Er is iets misgegaan. Probeer het later opnieuw.',
      documentCodeDuplicate: 'Documentcode bestaat al',
      unsupportedFileFormat: 'Niet-ondersteund bestandstype. Upload een geldig afbeeldingsbestand.',
      tableHeaders: {
        productName: 'Productnaam',
        hsCode: 'HS-code',
        eudrDocumentCode: 'EUDR-documentcode',
        subProduct: 'Subproducten',
        dateAdded: 'Datum Toegevoegd',
        action: 'Acties',
      },
      documentCodeSaved: 'Documentcode is succesvol opgeslagen.',
    },
    finalReport: {
      title: 'Eindrapport Mengsels',
      reportStatus: 'Rapportstatus',
      blendTitle: 'Titel Mengsel',
      blendCode: 'Code Mengsel',
      finalProduct: 'Eindproduct',
      finalProductCode: 'Code Eindproduct',
      blendDescription: 'Beschrijving Mengsel',
      processType: 'Type Proces',
      netMass: 'Netto Massa',
      volume: 'Volume',
      blendLotId: 'Lot-ID Mengsel',
      finalProductLotId: 'Lot-ID Eindproduct',
      internalReferenceNumber: 'Intern Referentienummer',
      eudrReferenceNumber: 'EUDR Referentienummer',
      activity: 'Activiteit',
      countryOfActivity: 'Land van Activiteit',
      countryOfEntry: 'Land van Binnenkomst',
      dueDiligenceReportStatus: 'Status Due Diligence Rapport',
      containerId: 'Container-ID',
      operatorData: 'Operatorgegevens',
      name: 'Naam',
      country: 'Land',
      isoCode: 'ISO-code',
      eoriNumber: 'EORI-nummer',
      reportSummary: {
        title: 'Samenvatting Rapport',
        totalDdsReports: 'Totaal Aantal DDS-rapporten',
        totalGeofencePolygons: 'Totaal Aantal Geofence-polygonen',
        totalGeofencePoints: 'Totaal Aantal Geofence-punten',
        totalDeforestationAssessments: 'Totaal Aantal Ontbossingsevaluaties',
        totalRiskAssessments: 'Totaal Aantal Risicobeoordelingen',
        totalFarms: 'Totaal Aantal Boerderijen',
        totalHighDeforestationFarms: 'Aantal Boerderijen met Hoge Ontbossing',
        totalLowZeroRiskFarms: 'Aantal Boerderijen met Laag of Geen Risico',
        totalArea: 'Totale Oppervlakte (ha)',
        averageGeofenceArea: 'Gemiddelde Geofence Oppervlakte (ha)',
        totalHighRiskFarmArea: 'Totale Oppervlakte van Risicovolle Boerderijen',
        totalLowZeroRiskFarmArea:
          'Totale Oppervlakte van Boerderijen met Laag of Geen Risico',
        productionPlaces: 'Productieplaatsen',
        productionPlacesTooltip: 'Details over de productielocaties',
        declarationStatement: 'Verklaring van de Operator',
        declarationStatementTooltip: 'Officiële verklaring door de operator',
        declarationText1:
          '[Naam] {name}, verklaar hierbij dat alle gegevens die bij deze verzending zijn ingediend naar mijn beste weten en overtuiging accuraat zijn.',
        declarationText2:
          'Ik, [Naam] {name}, bevestig dat ik de boerderijen die aan deze verzending zijn gekoppeld heb bezocht en hun naleving van lokale wetten en regelgeving met betrekking tot ontbossing heb bevestigd.',
      },
      blendProducts: {
        title: 'Mengselproducten',
        product: 'Product',
        subProduct: 'Subproduct',
        country: 'Land',
        reference: 'EUDR / Intern Referentienummer',
        containerId: 'Container-ID',
        farmsQuantity: 'Boerderijen & Hoeveelheid',
        submissionDate: 'Indiendatum',
        status: 'Status',
      },
      activityLog: {
        title: 'Activiteitenlogboek',
        user: 'Gebruiker',
        userRole: 'Gebruikersrol',
        ipAddress: 'IP-adres',
        dateTime: 'Datum & Tijd',
        segment: 'Segment',
        activityDescription: 'Activiteitenbeschrijving',
      },
      declaration: {
        title: 'Verklaring van de Operator',
        name: 'Naam',
        address: 'Adres',
        dateTime: 'Datum & Tijd',
      },
      buttons: {
        discard: 'Verwijderen',
        reject: 'Afwijzen',
        edit: 'Bewerken',
        finalize: 'Afronden',
        download: 'Downloaden',
        uploadToEuPortal: 'Uploaden naar EU-portaal',
        submit: 'Indienen',
      },
    },
  }
};